export default {"src":"/_next/static/media/sydney-opera-house_2.4755d9c1.svg","height":512,"width":512};